import React from 'react';
import { Messages } from '../../codegen/Localize';
import { ExplorableItemType } from '../../ts/models/ContentType';
import { DraftStyles } from '../styles/DraftStyles';
import { DraftTagType } from '../types/DraftsTypes';
import { Tooltip } from '@tableau/widgets';

export interface DraftTagProps {
  readonly draftTag: string;
  readonly tagType: DraftTagType;
  readonly explorableItemType: ExplorableItemType;
}

export class DraftTag extends React.Component<DraftTagProps>{
  public render() {
    /* eslint-disable jsx-a11y/no-noninteractive-tabindex */
    return (
      <Tooltip getContent={this.getTooltipContent} maxWidth={200}>
        <div className={this.getTagStyle()}
        data-tb-test-id={`${this.props.tagType}-tag`}
        tabIndex={this.props.tagType === DraftTagType.staticTag ? -1 : 0}  //disable tabbing when tag has no tooltip
        >
          {this.props.draftTag}
        </div>
      </Tooltip>
    );
  }

  private getTagStyle(): string {
    if (this.props.draftTag === Messages.draftTag()) {
      return DraftStyles.DraftTag;
    } else if (this.props.draftTag === Messages.draftUnpublishedTag()) {
      return DraftStyles.DraftUnpublishedTag;
    }
  }

  private getTooltipContent = (): JSX.Element => {
    let CONTENT_TYPE = this.props.explorableItemType as string;
    let content: string;
    switch (this.props.tagType) {
      case DraftTagType.neverPublished:  //never published
        content = Messages.draftUnpublishedTagTooltip({ CONTENT_TYPE });
        break;
      case DraftTagType.unpublished:  // changes to existing workbook
        content = Messages.draftTagTooltip({ CONTENT_TYPE });
        break;
      case DraftTagType.staticTag: //fall through
      default:
        break;
    }
    return (
      content &&
      <div data-tb-test-id={`${this.props.tagType}-drafttag-tooltip`}>
        {content}
      </div>
    );
  }
}